export default __webpack_public_path__ + "static/media/bg28.3ead17a8.jpg";